module.exports = __webpack_public_path__ + "static/media/logo-light.fa343a8b.png";